import React from "react";
import { Card, CardMedia, Grid, Typography } from "@material-ui/core";
import AboutImage from "../image/AboutImage.jpeg";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  img: {
    paddingTop: "56.25%", // 16:9
    height: "0%",
    width: "31%",
    borderRadius: "24px",
    margin: "auto",
  },
  card: {
    // height: "500px",
    width: "80%",
    overflow: "hidden",
    padding: "20px",
    margin: "40px auto",
    borderRadius: "20px",
  },
});

const AboutUs = () => {
  const classes = useStyles();
  return (
    <div>
      <Card className={classes.card}>
        <Grid container>
          <Grid item xs={12} sm={6} md={6}>
            <CardMedia className={classes.img} image={AboutImage} />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography>adfasfdas</Typography>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default AboutUs;
